import { ErrorHandler, Injectable } from '@angular/core';

const CHUNK_RELOAD_KEY = 'chunk_load_reload';

@Injectable()
export class ChunkLoadErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    const message =
      (error as { message?: string })?.message ||
      (error as { rejection?: { message?: string } })?.rejection?.message ||
      '';

    const isChunkError =
      message.includes('ChunkLoadError') ||
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module');

    if (isChunkError && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
      globalThis.location.reload();
      return;
    }

    super.handleError(error);
  }
}
